import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MyProfile from './pages/MyProfile';
import DemoPage from './pages/DemoPage';
import IntegrationsPage from './pages/IntegrationsPage';
import ThemeAssets from './components/common/ThemeAssets';
import ScriptLoader from './components/common/ScriptLoader';
import PrivateRoute from './components/common/PrivateRoute';
import './assets/scss/core.scss';
import auth from './utils/auth';

const App = () => {
  const [assetsReady, setAssetsReady] = useState(false);

  useEffect(() => {
    auth.initAuth();
    auth.captureAuthRedirect();
  }, []);

  return (
    <Router>
      <ThemeAssets onReady={() => setAssetsReady(true)} />
      <ScriptLoader />{/* keep scripts async; gate only on CSS if you want */}

      {assetsReady ? (
        <Switch>
          <Route path="/" exact component={LoginPage} />
          <Route path="/login" exact component={LoginPage} />
          <Route path="/forgot-password" component={LoginPage} />
          <Route path="/reset-password" component={LoginPage} />
          <Route path="/demo/:username" component={DemoPage} />
          <PrivateRoute path="/dashboard" component={DashboardPage} />
          <PrivateRoute path="/profile" component={MyProfile} />
          <PrivateRoute path="/integrations" component={IntegrationsPage} />
        </Switch>
      ) : (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f5f5f9',
            zIndex: 9999
          }}
        >
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}
    </Router>
  );
};

export default App;